import { createContext, useMemo, useState } from 'react';
import { SfFunnelMoreButtonProps } from '../../../../funnel-map-canvas/types';
import { useFeatureToggle } from '../../../../../feature-flags/useFeatureToggle';

export type SfFunnelMenuContextType = {
  anchorEl: { anchorEl: HTMLElement; funnelId: string } | null;
  setAnchorEl: (anchorEl: { anchorEl: HTMLElement; funnelId: string } | null) => void;
  sfFunnelMoreButton?: SfFunnelMoreButtonProps;
};

export const SfFunnelMenuContext = createContext<SfFunnelMenuContextType>({
  anchorEl: null,
  setAnchorEl: () => {},
});

export const SfFunnelMenuContextProvider = ({ children }: { children: React.ReactNode }) => {
  const { deleteFunnel } = useFeatureToggle();
  const [anchorEl, setAnchorEl] = useState<{ anchorEl: HTMLElement; funnelId: string } | null>(
    null,
  );

  const sfFunnelMoreButton: SfFunnelMoreButtonProps | undefined = useMemo(() => {
    if (!deleteFunnel) {
      return undefined;
    }
    return {
      display: true,
      openedFunnelId: anchorEl?.funnelId,
      onClick: ({ event, funnelId }) => {
        setAnchorEl({
          anchorEl: event.currentTarget as HTMLElement,
          funnelId,
        });
      },
    };
  }, [anchorEl, deleteFunnel]);

  return (
    <SfFunnelMenuContext.Provider
      value={useMemo(
        () => ({ anchorEl, setAnchorEl, sfFunnelMoreButton }),
        [anchorEl, setAnchorEl, sfFunnelMoreButton],
      )}
    >
      {children}
    </SfFunnelMenuContext.Provider>
  );
};
